<!-- ComponentConfig.vue (Vue 2 兼容) -->
<template>
  <div class="config-container" style="position: relative">
    <el-form label-position="top" >

      <!--轮播图配置-->
      <template v-if="config['componentName'] === 'BannerComponent'">
        <div class="carousel-form" style="padding-bottom: 30px;">
          <div>
            <el-form-item label="轮播图类型" style="margin-right: 20px">
              <el-select v-model="config['config'].listType" placeholder="请选择" @change="bannerTypeChange">
                <el-option
                  v-for="item in bannerTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <el-form-item label="轮播间隔(毫秒)">
            <el-input-number
              v-model="config['config'].interval"
              :min="500"
              :max="10000"
              :step="500"
            />
          </el-form-item>

          <el-form-item label="模块名称">
            <el-input
              v-model="config['config'].moduleName"
              placeholder="请输入模块名称"
              clearable />
          </el-form-item>

          <div v-for="(item, index) in config['config'].mediaUrls" :key="index" class="carousel-item">
            <el-card class="" :body-style="{padding: '0px 20px'}">
              <div slot="header" class="clearfix">
                <span>轮播图 #{{ index + 1 }}</span>
                <el-button
                  v-if="config['config'].mediaUrls.length > 1"
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="removeCarouselItem(index)">
                  删除
                </el-button>
              </div>

              <div class="form-row">
                <el-form-item label="上传图片或视频">
                  <el-upload
                    action="#"
                    :on-change="(file) => handleMediaChange(file, index)"
                    :auto-upload="false"
                    :show-file-list="false"
                    accept="image/*,video/*"
                  >
                    <el-button size="small" type="primary" style="width: 120px">
                      点击上传
                    </el-button>
                  </el-upload>
                  <div v-if="item.mediaUrl !== ''" class="media-preview">
                    <div v-if="item.mediaType === 'image'">
                      <img :src="item.mediaUrl" class="preview-image" />
                    </div>
                    <div v-else-if="item.mediaType === 'video'">
                      <video controls class="preview-video">
                        <source :src="item.mediaUrl" />
                      </video>
                    </div>
                  </div>
                </el-form-item>
              </div>

              <div class="form-row">
                <el-form-item label="关联商品">
                  <el-button size="small" @click="openEditDialog(index)" style="width: 120px"  >选择商品</el-button>
                  <span style="margin-left: 10px;">{{item.productName}}</span>
                </el-form-item>
              </div>
            </el-card>
          </div>

          <el-button type="primary" @click="addCarouselItem" icon="el-icon-plus">
            添加轮播图
          </el-button>
        </div>

        <div class="submit-section">
          <el-button
            type="success"
            @click="handleSubmit('swiper')"
            :loading="submitting">
            保存轮播图
          </el-button>
        </div>
      </template>

      <!-- 商品列表配置 -->
      <template v-if="config['componentName'] === 'GoodsList'" style="padding-bottom: 20px;">
        <div>
          <el-form-item label="列表类型" style="margin-right: 20px">
            <el-select v-model="config['config'].listType" placeholder="请选择" @change="listTypeChange">
              <el-option
                v-for="item in listTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </div>

        <el-form-item label="每行列数" v-if="config['config'].listType === 'normal'">
          <el-radio-group v-model="config['config'].columns">
            <el-radio-button :label="1">1列</el-radio-button>
            <el-radio-button :label="2">2列</el-radio-button>
            <el-radio-button :label="4">4列</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="模块名称">
          <el-input
            v-model="config['config'].moduleName"
            placeholder="请输入模块名称"
            clearable />
        </el-form-item>

        <el-form-item label="商品列表">
          <el-tabs v-model="currentTab" type="card" closable @tab-remove="removeTab" :before-leave="activeTab" ref="calendarDom">
            <el-tab-pane
              v-if="goodList[0].tabName !== ''"
              v-for="(item, index) in goodList"
              :key="`tab-${index}${Date.now()}`"
              :name="item.tabName"
            >
              <!-- 自定义标签标题（支持双击编辑） -->
              <span slot="label" @dblclick="startEdit(index,item.tabName)">
              <template>
                {{ config['config'].listType === 'calendar' ? new Date(Number(item.tabName)).getDate() : item.tabName }}
                <i slot="reference" class="el-icon-edit" style="margin-left:5px;" @click="startEdit(index,item.tabName)"></i>
              </template>
            </span>
            </el-tab-pane>
          </el-tabs>
          <el-switch
            v-if="config['config'].listType === 'calendar'"
            v-model="goodList[activeGoodIndex].isNewDate"
            active-text="上新"
            inactive-text="常规">
          </el-switch>
          <div
            v-for="(item, idx) in goodList[activeGoodIndex].tabData"
            :key="idx"
            style="justify-content: space-between"
          >
            <div v-if="item.productInfo" class="goods-config-item">
              <div style="display: flex;align-items: center">
                <el-image
                  style="width: 60px; height: 60px"
                  :src="$config.product_image_url + 'cover_image/' + item.productInfo.coverImage"
                  fit="contain"></el-image>
                <div style="margin-left: 15px">{{item.productInfo.name}}</div>
                <div style="margin-left: 20px">￥{{item.productInfo.price}}</div>
              </div>
              <el-button
                type="danger"
                icon="el-icon-delete"
                circle
                size="mini"
                @click="removeGoods(idx)"
              />
            </div>
          </div>
          <el-button type="primary" icon="el-icon-plus" size="small" @click="addGoods" style="width: 120px"  >添加商品</el-button>
          <el-button size="small" @click="addTab">添加类目</el-button>
        </el-form-item>

        <div class="submit-section">
          <el-button
            type="success"
            @click="handleSubmit('goodList')"
            :loading="submitting">
            保存商品列表
          </el-button>
        </div>
      </template>

      <!-- 热词配置 -->
      <template v-if="config['componentName'] === 'HotSearchComponent'" style="padding-bottom: 20px;">

        <el-form-item label="模块名称">
          <el-input
            v-model="config['config'].moduleName"
            placeholder="请输入模块名称"
            clearable />
        </el-form-item>

        <el-form-item label="热词列表">

          <el-tag
            v-for="(word,index) in config['config'].hotWords"
            :key="index"
            closable
            @close="cancelTag(index)"
            type="info"
            style="margin-right: 10px"
          >
            {{word}}
          </el-tag>

          <div>
            <el-input v-model="hotWord" style="margin-top: 10px" @keydown.enter.native="addWord"></el-input>
            <el-button type="primary" icon="el-icon-plus" size="small" @click="addWord" style="width: 120px"  >添加热词</el-button>
          </div>
        </el-form-item>

        <div class="submit-section">
          <el-button
            type="success"
            @click="handleSubmit('hotWords')"
            :loading="submitting">
            保存热词列表
          </el-button>
        </div>
      </template>

      <!-- 优惠券 -->
      <template v-if="config['componentName'] === 'CouponComponent'" style="padding-bottom: 20px;">

        <el-form-item label="模块名称">
          <el-input
            v-model="config['config'].moduleName"
            placeholder="请输入模块名称"
            clearable />
        </el-form-item>

        <div v-for="(item, index) in couponList" :key="index" class="carousel-item">
          <el-card class="" :body-style="{padding: '0px 20px'}">
            <div slot="header" class="clearfix">
              <span>优惠券 #{{ index + 1 }}</span>
              <el-button
                v-if="couponList.length > 1"
                style="float: right; padding: 3px 0"
                type="text"
                @click="removeCouponItem(index)">
                删除
              </el-button>
            </div>

            <div class="form-row">
              <el-form-item label="关联优惠券">
                <el-button size="small" @click="openCouponEditDialog(index)" style="width: 120px"  >选择优惠券</el-button>
                <span style="margin-left: 10px;">{{item.couponInfo.couponName}}</span>
              </el-form-item>
            </div>
          </el-card>
        </div>

        <el-button type="primary" @click="addCouponItem" icon="el-icon-plus" style="margin-bottom: 10px">
          添加优惠券
        </el-button>


        <div class="submit-section">
          <el-button
            type="success"
            @click="handleSubmit('coupon')"
            :loading="submitting">
            保存优惠券
          </el-button>
        </div>
      </template>

      <el-dialog
        title="重命名"
        :visible.sync="renameVisible"
        width="20%"
        :close-on-click-modal="false"
        :before-close="renameClose">
        <div style="margin-top: 20px">
          <el-date-picker
            v-if="config['config'].listType === 'calendar'"
            v-model="renameValueDate"
            @change="calendarChange"
            type="date"
            placeholder="选择日期">
          </el-date-picker>
          <el-input v-else v-model="renameValue"></el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="renameVisible = false">取 消</el-button>
          <el-button type="primary" @click="confirmRename">确 定</el-button>
        </span>
      </el-dialog>

    </el-form>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'ComponentConfig',
  props: {
    config: {
      type: Object,
      required: true
    },
    category: {
      type: String,
      required: true
    },
    sortIndex: {
      type: Number,
      required: true
    },
    needDelImages: Array
  },
  data() {
    return {
      moduleType: '',
      carouselItems: [
        { mediaUrl: '',  productId: '',productName: '',mediaType: '' ,mediaFile: ''}
      ],
      submitting: false,
      carouselId: '',
      currentImages: [], //当前冗余图片数组

      currentTab: '',
      editableTabs: [],
      tabIndex: 0,

      goodList: [{
        tabName: '',
        tabData: []
      }],
      isRank: false,
      isNowrap: false,
      activeGoodIndex: 0,

      renameVisible: false,
      renameIndex: null, //修改名称时对应的数组下标
      renameValue: null,

      hotWord: '',

      couponList: [{
        couponInfo: {
          couponName: '',
          couponPrice: '',
          usePrice: 0,
          categoryLimit: '1',
        }
      }],
      renameValueDate: '',

      //商品列表参数
      listTypeOptions: [{
        value: 'normal',
        label: '常规列表'
      },{
        value: 'calendar',
        label: '日历预告'
      },{
        value: 'nowrap',
        label: '单列横向'
      },{
        value: 'rank',
        label: '排行榜'
      }],

      //轮播图参数
      bannerTypeOptions: [{
        value: 'height',
        label: '长版'
      },{
        value: 'width',
        label: '宽版'
      }]

    }
  },
  mounted() {
    console.log('first create');
    //console.log('sortIndex',this.sortIndex);
    this.initComponent(this.config);
  },
  watch: {
    config: {
      handler(newVal){
        console.log('config change');
        this.initComponent(newVal)
      }
    }
  },
  methods: {
    initComponent(newVal){
      this.reset();

      this.carouselId = newVal.config.carouselId;
      if(newVal.componentName === 'BannerComponent'){
        this.moduleType = 'swiper'
        const carousels = [];
        const currentImages = []
        if(newVal.config.mediaUrls){
          newVal.config.mediaUrls.forEach( con => {
            // let temp = {
            //   mediaUrl: con.mediaUrl ? `${this.$config.product_image_url}index_image/${con.mediaUrl}` : '',
            //   productId: con.productInfo ? con.productInfo._id : '',
            //   productName: con.productInfo ? con.productInfo.name : '',
            //   mediaType: mt,
            //   mediaFile: ''
            // }
            // carousels.push(temp);

            currentImages.push(con.mediaUrl)
          })
        }
        //this.carouselItems = carousels;
        this.currentImages = currentImages;

      }else if(newVal.componentName === 'GoodsList'){
        this.moduleType = 'goodsList';
        this.goodList = newVal.config.goods;
        this.currentTab = newVal.config.goods[0].tabName || ''
      }else if(newVal.componentName === 'HotSearchComponent'){
        this.moduleType = 'hotSearch';
      }else if(newVal.componentName === 'CouponComponent'){
        this.moduleType = 'coupon';
        this.couponList = newVal.config.couponList;
      }
    },

    reset(){
      this.moduleType = '';
      this.carouselId = '';
      this.carouselItems = [
        { mediaUrl: '',  productId: '',productName: '',mediaType: '' ,mediaFile: ''}
      ];
      this.submitting = false;

      this.currentTab = '';
      this.activeGoodIndex = 0;
      this.goodList = [{
        tabName: '',
        tabData: []
      }];
      this.couponList = [{
        couponInfo: {
          couponName: '',
          couponPrice: '',
          usePrice: 0,
          categoryLimit: '1',
        }
      }]
    },

    openEditDialog(index){
      console.log('category')
      let that = this.$root.$children[0].$children[1].$children[0];
      that.selectDialogVisible = true;
      that.$set(that,'childrenObject',this);
      that.$set(that,'selectIndex',index);
      that.$set(that,'category','')
      that.$set(that,'isArraySelect',true);
    },
    openCouponEditDialog(index){
      let that = this.$root.$children[0].$children[1].$children[0];
      //console.log(that.selectCouponDialogVisible);
      that.selectCouponDialogVisible = true;
      that.$set(that,'childrenObject',this);
      that.$set(that,'selectCouponIndex',index);
    },

    addGoods() {
      console.log('add goods')
      let that = this.$root.$children[0].$children[1].$children[0];
      that.selectDialogVisible = true;
      that.$set(that,'childrenObject',this);
      that.$set(that,'category',this.category)
      that.$set(that,'isGoodsSelect',true);
    },

    removeGoods(idx) {
      this.goodList[this.activeGoodIndex].tabData.splice(idx, 1)
    },

    addCarouselItem() {
      // this.carouselItems.push({
      //   mediaUrl: '',  productId: '',productName: '',mediaType: '',mediaFile: ''
      // });
      this.config.config.mediaUrls.push({
        mediaUrl: '',  productId: '',productName: '',mediaType: '',mediaFile: ''
      });
    },
    removeCarouselItem(index) {
      //this.carouselItems.splice(index, 1);
      this.config.config.mediaUrls.splice(index, 1);
    },
    addCouponItem() {
      this.couponList.push({
        couponInfo: {
          couponName: '',
          couponPrice: '',
          usePrice: 0,
          categoryLimit: '1',
        }
      });
    },
    removeCouponItem(index) {
      this.couponList.splice(index, 1);
    },

    //处理图片
    handleMediaChange(file, index) {
      // 获取文件类型（图片/视频）
      const fileType = file.raw.type.startsWith('image') ? 'image' : 'video';
      //console.log(file)
      this.needDelImages.push(`${this.currentImages[index]}`);
      // this.currentImages.splice(index, 1);

      // 本地预览
      const reader = new FileReader();
      reader.onload = (e) => {
        // this.config.config.mediaUrls[index].mediaUrl = e.target.result
        // this.config.config.mediaUrls[index].mediaFile = file.raw
        // this.config.config.mediaUrls[index].mediaType = fileType;
        this.$emit('update-media', {
          index,        // 索引
          mediaUrl: e.target.result,   // DataURL 预览地址
          mediaFile: file.raw, // 原始 File 对象
          mediaType: fileType  // 文件类型
        });
      };
      reader.readAsDataURL(file.raw);
    },

    //提交保存
    async handleSubmit(type){
      this.submitting = true;
      try {
        let options = {
          moduleName: this.config.config.moduleName,
          moduleType: this.moduleType,
          category: this.category,
        };

        if(type === 'coupon'){ //优惠券参数
          options.couponList = this.config.config.couponList.map(coupon => {
            return {
              couponId: coupon.couponInfo._id,
            }
          })
        }else if(type === 'hotWords'){ //热词参数
          options.hotWords = this.config.config.hotWords || []
        }else if(type === 'goodList'){ //商品列表参数
          const _goods = [];
          for (const item of this.goodList) {
            let temp = {
              tabName: item.tabName,
              tabData: [],
            }
            if(this.config.config.listType === 'calendar' && item.isNewDate) temp.isNewDate = true;
            item.tabData.forEach(data => {
              if(data.productInfo){
                temp.tabData.push({
                  productId: data.productInfo._id
                })
              }
            })
            _goods.push(temp);
          }

          options.listType = this.config.config.listType || 'normal';
          options.arrange = this.config.config.columns || 2;
          options.goods = _goods;
        }else if(type === 'swiper'){
          // 2. 先上传所有媒体文件到服务器
          const formData = new FormData();
          this.config.config.mediaUrls.forEach(item => {
            // 如果是本地文件需要上传
            if(item.mediaFile) formData.append('uploadFiles',item.mediaFile)
          });

          const uploadResponse = await this.$request.file_upload('indexImage',formData);

          const uploadedUrls = uploadResponse.data;

          // 3. 更新轮播图项的URL为服务器URL
          let urlIndex = 0;
          const itemsForSaving = this.config.config.mediaUrls.map(item => {
            if(item.mediaFile)
              return {
                productId: item.productId,
                mediaUrl: uploadedUrls[urlIndex++].filename
              }
            else{
              const i = item.mediaUrl.split('/');
              return {
                productId: item.productId,
                mediaUrl: i[i.length - 1]
              }
            }
          });

          options.listType = this.config.config.listType || 'height';
          options.interval = this.config.config.interval || 3000;
          options.mediaUrls = itemsForSaving

          //console.log(options);

        }

        if(this.carouselId) options.id = this.carouselId;
        const newCarousel = await this.$request.set_message('carousels',options);

        if(type === 'swiper'){
          await this.dropFile(this.needDelImages);
          this.needDelImages.splice(0,this.needDelImages.length);
        }

        if(newCarousel.code === 0){
          this.$message.success('保存成功！');
          this.$emit('update', newCarousel.data)
        }else{
          this.$message.success('保存失败！');
        }
      }catch (e){
        console.error('保存失败:', e);
        if (e.response) {
          this.$message.error(`保存失败: ${e.response.data.message || '服务器错误'}`);
        } else {
          this.$message.error('保存失败: 网络错误或服务器异常');
        }
      } finally {
        this.submitting = false;
      }
    },

    //请求执行删除
    async dropFile(urls){
      //console.log('删除图片')
      const opts = []
      urls.forEach((file) => {
        const temp = file.split("/")
        opts.push(`product/index_image/${temp[temp.length - 1]}`)
      })
      //console.log(opts)
      await this.$request.drop_files(opts);
    },

    addTab() {
      let newTabName = '';
      if(this.config.config.listType === 'calendar'){
        newTabName = new Date().getTime() + (24 * 60 * 60 * 1000 * this.tabIndex++) + ""
      }else{
        newTabName = '未命名' + ( this.tabIndex++ )
      }

      if(this.goodList[0].tabName !== ''){
        let opt = {
          tabName: newTabName,
          tabData: []
        }
        if(this.config.config.listType === 'calendar') opt.isNewDate = true;
        this.goodList.push(opt)
      }else{
        this.goodList[0].tabName = newTabName;
        if(this.config.config.listType === 'calendar') this.goodList[0].isNewDate = true;
      }
      this.currentTab = newTabName;
      this.activeGoodIndex = this.goodList.length - 1;

    },

    activeTab(activeName){
      for(let i=0; i<this.goodList.length; i++){
        if(this.goodList[i].tabName === activeName){
          this.activeGoodIndex = i;
          break;
        }
      }
    },

    //需修正
    removeTab(targetName) {
      let activeGoodIndex = 0;
      let nextTab = ''
      for(let [index,tab] of this.goodList.entries()){
        if(tab.tabName === targetName){
          if(this.currentTab === targetName){
            activeGoodIndex = this.goodList[index + 1] ? index: index - 1;
            nextTab = this.goodList[index + 1] || this.goodList[index - 1];
          }
          if(this.goodList.length === 1){
            this.goodList[0].tabName = "";
            this.goodList[0].tabData = [];
          }
          else this.goodList.splice(index, 1)
          break;
        }
      }
      if(nextTab) this.currentTab = nextTab;
      if(activeGoodIndex) this.activeGoodIndex = activeGoodIndex < 0 ? 0 : activeGoodIndex;
    },

    // 开始编辑
    startEdit(index,name) {
      this.renameIndex = index;
      this.renameValue = name;
      this.renameVisible = true;
      if(this.config.config.listType === 'calendar'){
        const y = new Date(Number(name));
        this.renameValueDate = `${y.getFullYear()}-${y.getMonth()+1}-${y.getDate()}`
      }
    },

    renameClose(){
      this.renameIndex = null;
      this.renameValue = null;
      this.renameVisible = false;
      this.renameValueDate = null;
    },

    calendarChange(val){
      this.renameValue = new Date(val).getTime();
    },

    confirmRename(){
      if(this.config.config.listType === 'calendar'){
        if(this.renameIndex - 1 >= 0 && Number(this.renameValue) < Number(this.goodList[this.renameIndex-1].tabName)){
          this.adjustPosition(this.renameIndex,this.renameValue)
        }else{
          this.goodList[this.renameIndex].tabName = this.renameValue;
        }
        if(this.activeGoodIndex === this.renameIndex) this.currentTab = this.renameValue;
        this.renameVisible = false;
      }else{
        this.goodList[this.renameIndex].tabName = this.renameValue;
        if(this.activeGoodIndex === this.renameIndex) this.currentTab = this.renameValue;
        this.renameVisible = false;
      }
    },

    adjustPosition(index, newValue){
      //边界检查
      if(index < 0 || index >= this.goodList.length) return;

      //更新当前元素值
      this.goodList[index].tabName = newValue;

      // 从当前索引向前遍历并交换位置
      while (index > 0) {
        const prevValue = this.goodList[index - 1].tabName; // 前一个元素的值
        if (Number(newValue) >= Number(prevValue)) break; // 终止条件：已大于前一个元素

        // 交换位置：使用数组解构交换相邻元素[8](@ref)
        [this.goodList[index], this.goodList[index - 1]] = [this.goodList[index - 1], this.goodList[index]];
        index--; // 更新当前元素的新索引
      }
    },

    addWord(){
      if(this.hotWord === ''){
        this.$message('请输入热词')
        return;
      }
      this.config.config.hotWords.push(this.hotWord);
      this.hotWord = "";
    },

    cancelTag(index){
      this.config.config.hotWords.splice(index, 1);
    },

    listTypeChange(type){
      this.goodList.splice(0,this.goodList.length);
      const nav = document.querySelector('.el-tabs__nav');

      if(type === 'calendar'){
        const thisDate = new Date();
        const thisMonthDay = this.$util.getMonthDays(thisDate.getMonth() + 1 , thisDate.getFullYear())
        for(let i = 0; i < thisMonthDay; i++){
          let name = i + 1
          let opt = {
            tabName: new Date(`${thisDate.getFullYear()}-${thisDate.getMonth() + 1}-${name}`).getTime() + "",
            tabData: [],
            isNewDate: true
          }
          this.goodList.push(opt)
        }
        this.currentTab = this.goodList[0].tabName;

        if (nav) {
          nav.style.display = 'flex';
          nav.style.flexWrap = 'wrap';
        }

      }else if(type === 'normal'){
        let opt = {
          tabName: '',
          tabData: []
        }
        this.goodList.push(opt)

        if (nav) {
          nav.style.display = '';
          nav.style.flexWrap = '';
        }
      }else{
        let opt = {
          tabName: '未命名',
          tabData: []
        }
        this.goodList.push(opt)
        this.currentTab = this.goodList[0].tabName

        if (nav) {
          nav.style.display = '';
          nav.style.flexWrap = '';
        }
      }
    },

    bannerTypeChange(e){
      console.log(e,this.config);
    }
  }
}
</script>

<style scoped>
.goods-config-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px;
  margin-bottom: 10px;
  background-color: #fff;
}

.image-item .el-input {
  flex: 1;
  margin-right: 10px;
}

.goods-config-item .el-input {
  margin-bottom: 5px;
}

.carousel-form {
  padding-top: 10px;
}

.carousel-item {
  margin-bottom: 20px;
}

.form-row {
  margin-bottom: 15px;
}

.media-preview {
  margin-top: 15px;
}

.preview-image {
  max-width: 100%;
  max-height: 200px;
  display: block;
}

.preview-video {
  max-width: 100%;
  max-height: 200px;
  display: block;
}

.submit-section {
  position: sticky;
  bottom: -1px;
  padding: 20px;
  border-top: 1px solid #f0f0f0;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
}

.el-tabs .el-tabs__nav{
  display: flex !important;
  flex-wrap: wrap !important;
}
</style>



// WEBPACK FOOTER //
// src/components/instrument/ComponentConfig.vue